import { CAPABILITY_META } from '../constants/capabilityMeta'
import { ModelDetailSection } from './ModelDetailSection'
import type { ChatModelMetadata, UnifiedModel } from '../types/unified-model.types'
import { DocAccordion } from '@/features/docs/components'
import { getFAQSchema, renderJsonLd } from '@/lib/structured-data'

interface ModelDetailFAQProps {
  model: UnifiedModel & { metadata: ChatModelMetadata }
}

export function ModelDetailFAQ({ model }: ModelDetailFAQProps) {
  const capabilityLabels = model.metadata.capabilities.map((c) => CAPABILITY_META[c]?.label ?? c).join(', ')

  const faqs = [
    {
      question: `How is ${model.name} billed on ModelStack?`,
      answer: `ModelStack bills based on actual request usage. Input, output, cache, and any other applicable rates follow the live pricing table on this page. Final request costs are available in the console.`,
    },
    {
      question: `What are the context window and maximum output for ${model.name}?`,
      answer: `${model.name} has a ${model.metadata.maxContext} context window and supports up to ${model.metadata.maxOutput} of output.`,
    },
    {
      question: `How can I call ${model.name} through ModelStack?`,
      answer: `Use the model ID \`${model.id}\` with any OpenAI-compatible SDK pointed at the ModelStack API — see the code examples above for Python, Node.js, and cURL.`,
    },
    {
      question: `Which capabilities does ${model.name} support?`,
      answer: `${model.name} supports: ${capabilityLabels}.`,
    },
  ]

  return (
    <ModelDetailSection title="Frequently asked questions">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: renderJsonLd(getFAQSchema(faqs)) }}
      />
      <div className="flex flex-col gap-2">
        {faqs.map((faq) => (
          <DocAccordion key={faq.question} title={faq.question}>
            {faq.answer}
          </DocAccordion>
        ))}
      </div>
    </ModelDetailSection>
  )
}
